module.exports = __webpack_public_path__ + "img/12-min.b8239fde.jpg";